import type { Action } from 'react-sweet-state';
import { type State, codeFeatureStates } from '../types';

export const setFeatureState =
	(isEnabled: boolean): Action<State> =>
	({ getState, setState }) => {
		const currentState = getState();
		const newState = isEnabled ? codeFeatureStates.ENABLED : codeFeatureStates.DISABLED;
		if (currentState.state !== newState) {
			setState({ state: newState });
		}
	};
